module.exports = __webpack_public_path__ + "img/account-approved.0dade4da.svg";